module.exports = __webpack_public_path__ + "media/tumor.8bd8bce7.wav";